<!-- Contextual bar -->
@if (config$ | async; as config) {
    <div class="contextual-bar-wrap">
        <div class="contextual-bar">

            <!-- Back button -->
            <button class="circle-btn" (click)="goBack()" aria-label="Go back">
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-back-arrow-left'">
                </app-custom-icon>
            </button>

            <!-- Section switcher -->
            <button
                type="button"
                class="section-switcher"
                (click)="toggleSwitcher()"
                [attr.aria-label]="'Switch section, current: ' + config.currentLabel"
                [attr.aria-expanded]="showSwitcher">
                <span class="section-label">{{ config.currentLabel }}</span>
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-chevron-up'">
                </app-custom-icon>
            </button>

            <!-- Add button (conditional) -->
            @if (config.showAdd) {
                <button
                    type="button"
                    class="circle-btn circle-btn--blue"
                    (click)="triggerAdd(config)"
                    aria-label="Add">
                    <app-custom-icon
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="'icon-add-new'">
                    </app-custom-icon>
                </button>
            }
        </div>
        <app-rise-agent-mobile-fab *featureFlag="'riseAgent'"></app-rise-agent-mobile-fab>
    </div>

    <p-sidebar
        [(visible)]="showSwitcher"
        [fullScreen]="true"
        appendTo="body"
        [showCloseIcon]="false"
        styleClass="p-0 w-full min-h-screen flex flex-column"
        (onHide)="closeSwitcher()">
        <ng-template pTemplate="headless">
            <div
                class="flex flex-column h-screen min-h-0 w-full">
                <div
                    class="flex align-items-center justify-content-between flex-shrink-0 px-3 py-3 border-bottom-1 border-color-primary surface-card gap-2">
                    <h2 class="m-0 text-xl font-semibold text-color">
                        {{ config.parentLabel }}
                    </h2>
                    <p-button
                        type="button"
                        [text]="true"
                        icon="pi pi-times"
                        (onClick)="closeSwitcher()"
                        [attr.aria-label]="'Close'" />
                </div>
                <div class="flex-1 min-h-0 overflow-y-auto">
                    <ul class="contextual-switcher-list m-0 p-0 list-none">
                        @for (
                            option of config.siblings;
                            track option.label;
                            let isLast = $last
                        ) {
                            <li
                                class="border-color-primary"
                                [ngClass]="{ 'border-bottom-1': !isLast }">
                                <button
                                    type="button"
                                    class="contextual-switcher-option"
                                    [routerLink]="option.link"
                                    [queryParams]="option.query"
                                    [class.contextual-switcher-option--active]="
                                        option.label === config.currentLabel
                                    "
                                    (click)="closeSwitcher()">
                                    <span class="contextual-switcher-marker"></span>
                                    <span class="contextual-switcher-label">{{
                                        option.label
                                    }}</span>
                                </button>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </ng-template>
    </p-sidebar>
}
